import React from "react";
import { cn } from "@/lib/utils";

/**
 * Tribe wordmark: lowercase "tribe" with purple "i".
 * @param {"light"|"dark"|"purple"} variant - light = ink + purple i; dark = white + purple-400 i; purple = all white
 */
export default function TribeLogo({ className, variant = "light", size = "md" }) {
  const sizeClass =
    size === "lg" ? "text-3xl" : size === "sm" ? "text-base" : "text-xl";
  const variantClass =
    variant === "dark"
      ? "tribe-logo--on-dark"
      : variant === "purple"
        ? "tribe-logo--on-purple"
        : "";

  return (
    <span
      className={cn("tribe-logo inline-flex items-baseline", sizeClass, variantClass, className)}
      aria-label="Tribe"
    >
      tr<span className="tribe-logo__i">i</span>be
    </span>
  );
}

/** Square monogram "t" for compact marks */
export function TribeMark({ className, size = 32 }) {
  return (
    <div
      className={cn(
        "rounded-xl bg-purple-500 flex items-center justify-center font-display font-bold text-white leading-none",
        className
      )}
      style={{ width: size, height: size, fontSize: size * 0.55 }}
      aria-hidden
    >
      t
    </div>
  );
}
